<template>
  <!-- STATION CARDS -->
  <div class="container">
    <div v-for="(station, index) in stations" :key="index">
      <v-card class="station-card" elevation="5" @click="openStation(station)">
        <v-img :src="station.thumbnail"></v-img>
        <v-card-title
          style="color: #FFFFFF; background-color: #4D5357; overflow-wrap: break-word;"
          >{{ station.name }}</v-card-title
        >
        <v-card-subtitle
          style="color: #FFFFFF; background-color: #4D5357; padding-top: 0px"
          >Station {{ station.stationnumber }}</v-card-subtitle
        >
      </v-card>
    </div>

    <!-- STATION MODAL -->
    <v-dialog v-model="showStationModal" width="fit-content">
      <div class="station-dialog">
        <v-toolbar dark color="#4D5357" :fixed="false">
          <v-toolbar-title style="margin-left: 20px; font-weight: bold;">
            {{ stationName }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            dark
            @click="showStationModal = false"
            style="margin-right: 5px !important;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card
          class="station-modal"
          style="height: fit-content; padding: 1em;"
        >
          <div v-for="(document, index) in stationDocuments" :key="index">
            <v-card
              class="doc-card"
              elevation="5"
              @click="openDocument(document)"
            >
              <v-card-title class="doc-title">{{ document.name }}</v-card-title>
              <v-card-subtitle>{{ document.description }}</v-card-subtitle>
            </v-card>
          </div>
        </v-card>
      </div>
    </v-dialog>

    <!-- PDF MODAL -->
    <v-dialog
      v-model="showPDFModal"
      width="85%"
      style="height:fit-content !important; overflow-y: hidden !important;"
    >
      <v-toolbar dark color="#4D5357" :fixed="false">
        <v-toolbar-title style="margin-left: 20px; font-weight: bold;">
          {{ documentName }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          dark
          @click="showPDFModal = false"
          style="margin-right: 5px !important;"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card style="height: fit-content">
        <iframe
          v-if="showPDFModal"
          :src="pdfUrl"
          width="100%"
          style="height:80vh"
        >
        </iframe>
      </v-card>
    </v-dialog>

    <!-- IMG MODAL -->
    <v-dialog
      v-model="showIMGModal"
      width="fit-content"
      height="70%"
      style="overflow-y: hidden !important;"
    >
      <v-toolbar dark color="#4D5357" :fixed="false">
        <v-toolbar-title style="margin-left: 20px; font-weight: bold;">
          {{ documentName }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          dark
          @click="showIMGModal = false"
          style="margin-right: 5px !important;"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <img :src="imgUrl" style="height: 80vh " />
      </v-card>
    </v-dialog>

    <!-- YT MODAL -->
    <v-dialog
      v-model="showYTModal"
      width="60vw"
      style="height:fit-content !important; overflow-y: hidden !important;"
    >
      <v-toolbar dark color="#4D5357" :fixed="false">
        <v-toolbar-title style="margin-left: 20px; font-weight: bold;">
          {{ documentName }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          dark
          @click="closeYT()"
          style="margin-right: 5px !important;"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <iframe
        id="yt"
        v-show="showYTModal"
        width="560"
        height="500"
        src="https://www.youtube.com/embed/qvLVHOogkg0"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </v-dialog>
  </div>
</template>

<script>
import { stations } from "@/components/VPH/stations.json";
export default {
  data() {
    return {
      stations: stations,
      showPDFModal: false,
      showIMGModal: false,
      showYTModal: false,
      showStationModal: false,
      stationName: "",
      stationDocuments: [],
      documentName: "",
      pdfUrl: "",
      imgUrl: "",
      ytUrl: ""
    };
  },
  watch: {
    showYTModal: function() {
      if (this.showYTModal === false) {
        console.log("Pausing YT");
        this.pauseYT();
      }
    }
  },
  methods: {
    openStation(station) {
      console.log(station);
      this.showStationModal = true;
      this.stationName = station.name;
      this.stationDocuments = station.documents;
    },

    openDocument(document) {
      console.log(document);

      if (document.pdf) {
        // URL param makes the doc fit horizontally in iframe
        this.pdfUrl = document.pdf + "#view=FitH";
        this.documentName = document.name;
        this.showPDFModal = true;
      } else if (document.img) {
        this.imgUrl = document.img;
        this.documentName = document.name;
        this.showIMGModal = true;
      } else if (document.yt) {
        this.ytUrl = "https://www.youtube.com/embed/" + document.yt;
        this.documentName = document.name;
        this.showYTModal = true;
      } else if (document.url) {
        window.open(document.url, "_blank").focus();
      }
    },

    closeYT() {
      this.showYTModal = false;
      this.pauseYT();
    },
    pauseYT() {
      // Reloading YT video so it does not play in the background
      const videos = document.querySelectorAll("iframe, video");
      Array.prototype.forEach.call(videos, function(video) {
        if (video.tagName.toLowerCase() === "video") {
          video.pause();
        } else {
          const src = video.src;
          video.src = src;
        }
      });
    }
  }
};
</script>

<style>
.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  gap: 4em;
}

.station-card {
  width: 25em;
}

.station-dialog {
  height: fit-content !important;
  overflow-y: hidden !important;
  width: 33vw !important;
}

.station-modal {
  background-color: #dfe0e0 !important;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  gap: 2em;
}

.doc-card {
  width: 30vw;
  min-width: 100px !important;
}

.doc-title {
  word-break: normal !important;
}

@media only screen and (max-width: 600px) {
  .station-card {
    width: 20em;
  }

  .station-dialog {
    height: fit-content !important;
    overflow-y: hidden !important;
    width: 85vw !important;
  }

  .station-modal {
    background-color: #dfe0e0 !important;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    gap: 2em;
  }

  .doc-card {
    width: 80vw;
  }
}
</style>
